module.exports = __webpack_public_path__ + "static/media/slide-maxilo-mobile.c099eb23.png";